import { toast } from "react-toastify";
import { server } from "../server";
import axios from "axios";

export const uploadDocumentToServer = async (
  file,
  filePath = "/partner-projects"
) => {
  const formData = new FormData();
  formData?.append("file", file);
  try {
    const { data } = await axios.post(
      `${server}/document/uploadDocument`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          staticPath: filePath,
        },
      }
    );
    return data?.downloadUrl || "";
  } catch (e) {
    toast.error(e?.response?.data || e?.message);
  }
};
